import config from "@/config";
import { initializeApp } from "firebase/app";
import {
    connectAuthEmulator,
    getAuth,
    GoogleAuthProvider,
} from "firebase/auth";

const {
    apiKey,
    authDomain,
    databaseURL,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
    emulatorUrl,
} = config.authentication.firebase;

export const provider = new GoogleAuthProvider();

const app = initializeApp({
    apiKey,
    authDomain,
    databaseURL,
    projectId,
    storageBucket,
    messagingSenderId,
    appId,
    measurementId,
});

export const firebaseAuth = getAuth(app);
firebaseAuth.useDeviceLanguage();

if (emulatorUrl) {
    connectAuthEmulator(firebaseAuth, emulatorUrl, { disableWarnings: true });
}

// Optimistically assume the user needs to be logged in, this saves us around
// 0.5s in the initial load.
(async () => {
    const user = firebaseAuth.currentUser;
    if (user) {
        user.getIdToken();
    }
})();
